import { useEffect, useRef } from 'react';

import { DayButtonProps } from 'react-day-picker';

import { getClassNames } from '../../../util/css';
import { dayButtonClass } from '../Datepicker.css';

export const DayButton = (props: DayButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const {
    day,
    modifiers: { focused },
    className,
    ...buttonProps
  } = props;

  useEffect(() => {
    if (focused) buttonRef.current?.focus();
  }, [focused]);

  return <button className={getClassNames(dayButtonClass, className)} name="day" ref={buttonRef} {...buttonProps} />;
};
